module.exports = __webpack_public_path__ + "img/bg-v.40d89553.svg";